<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
          <custom-tabs v-model="tabs1" :tab-items="tabItems" grow class="pa-5">
      <template v-slot:staticItems>
        <v-tabs-items v-model="tabs1">
          <v-tab-item>  
            <generate-multiple-qr-code-user/>
      </v-tab-item>
      <v-tab-item>
        <import-qr-page/>
      </v-tab-item>
        </v-tabs-items>
      </template>
          </custom-tabs>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QRCodeStyling from "qr-code-styling";
import { debounce } from "@/main";
import QrCodeData from "@/view/pages/qrland/qrCodeStyle/components/qrCodeData";
import QrCodeDots from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDots";
import QrCodeEye from "@/view/pages/qrland/qrCodeStyle/components/qrCodeEye";
import QrCodeOptions from "@/view/pages/qrland/qrCodeStyle/components/qrCodeOptions";
import QrCodeSquare from "@/view/pages/qrland/qrCodeStyle/components/qrCodeSquare";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import ImportQrPage from "../bulkQrs/ImportQrPage.vue";
import GenerateMultipleQrCodeUser from "./generateMultipleQrCodeUser.vue";

let qrCode = null;

export default {
  name: "generateMultipleQr",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrMaker,
    QrCodeData,
    QrCodeDots,
    QrCodeEye,
    QrCodeOptions,
    QrCodeSquare,
    ImportQrPage,
    GenerateMultipleQrCodeUser
  },

  data: () => ({
    tabs:0,
      tabItems: [
        { 
          text: "ساخت گروهی کیوار استاتیک", 
          icon: "qrcode-plus" 
        },
        {
          text: "ساخت گروهی کیوار دینامیک با اکسل",
          icon: "file-excel-outline",
        },
      ],

    helpData: [],
    componentName: "generate-Multiple-QrCode",
    serviceName: "Qrland",
    loading: false,
    qrSvgDataUrl: [],
    count: 1,
    tabs1: 0,
    toggle_exclusive: 4,
    selectFromGroup: false,
    options: {
      width: 300,
      height: 300,
      data: "https://qr2.in",
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "Q",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: null,
        // gradient: {
        //   type: "linear",
        //   rotation: 0,
        //   colorStops: [
        //     {offset: 0, color: "#933490"},
        //     {offset: 1, color: "#933490"}
        //   ]
        // }
      },
      backgroundOptions: {
        color: "#FFFFFFFF",
        gradient: null,
      },
      image: null,
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#6a1a4c",
          color2: "#6a1a4c",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        gradient: null,
        color: "#690a70",
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      cornersDotOptions: {
        type: "",
        color: "#b00cab",
        gradient: null,
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
    },
    panels: [
      { name: "QrCodeData", title: "رنگ و سایز کیوآر", icon: "qrcode-edit" },
      { name: "QrCodeDots", title: "طرح و رنگ نقطه ها", icon: "dots-triangle" },
      { name: "QrCodeEye", title: "طرح و رنگ چشم", icon: "bullseye" },
      {
        name: "QrCodeSquare",
        title: "طرح و رنگ حاشیه",
        icon: "rounded-corner",
      },
      { name: "QrCodeOptions", title: "تنظیمات کیوآر", icon: "cogs" },
    ],
    colors: [
      ["#649173", "#DBD5A4"],
      ["#B993D6", "#8CA6DB"],
      ["#870000", "#190A05"],
      ["#00d2ff", "#3a7bd5"],
      ["#DAD299", "#B0DAB9"],
      ["#E6DADA", "#274046"],
      ["#50C9C3", "#96DEDA"],
      ["#4b6cb7", "#182848"],
      ["#EC6F66", "#F3A183"],
      ["#5f2c82", "#49a09d"],
    ],
    stylesList: [
      ["", "dots", "square"],
      [
        "",
        "dot",
        "rounded",
        "classy",
        "classy-rounded",
        "square",
        "extra-rounded",
      ],
      ["", "dot", "square", "extra-rounded"],
    ],
  }),

  mounted() {
    qrCode = new QRCodeStyling(this.computedValue);
    this.ranColor().then(() => {
      this.updateStyle();
      this.$emit("save", this.options);
    });
  },

  watch: {
    tabs(val) {
      this.qrSvgDataUrl = [];

      if (val === 0) {
        this.ranColor().then(() => {
          this.updateStyle();
          this.$emit("save", this.options);
        });
      } else this.createAdvance();
    },
  },

  methods: {
    createAdvance() {
      this.loading = true;
      this.qrSvgDataUrl = [];

      const opt = this.options;
      let backgroundColor = this.isGradient(opt.backgroundOptions);
      let frontColor = this.isGradient(opt.dotsOptions);
      let cornerSquare = this.isGradient(opt.cornersSquareOptions);
      let cornerDots = this.isGradient(opt.cornersDotOptions);

      this.$api
        .post("/v2/qr-gen/group", {
          selectFromGroup: this.selectFromGroup,
          param: opt.data,
          type: "url",
          number: this.count,
          marker_out_color: cornerSquare.color,
          marker_in_color: cornerDots.color,
          marker_top_right_outline: "",
          marker_top_right_center: "",
          marker_bottom_left_outline: "",
          marker_bottom_left_center: "",
          different_markers_color: false,
          backcolor: backgroundColor.color,
          frontcolor: frontColor.color,
          radial: false,
          gradient: frontColor.isGradient,
          gradient_color: frontColor.color1,
          markers_color: true,
          level: "H",
        })
        .then(({ data }) => {
          let r = [];
          data.data.forEach((item) => r.push(item.content));
          this.qrSvgDataUrl = r;
        })
        .finally(() => (this.loading = false));
    },
    updateStyle(timer = false, options = this.options) {
      if (this.tabs === 1) {
        debounce(() => {
          this.createAdvance();
        }, 1500);
        return;
      }

      this.loading = true;

      this.$nextTick(() => {
        this.qrSvgDataUrl = [];
        const _this = this;

        async function* generator() {
          let i = 0;

          while (i < _this.count) {
            const field = [
              "dotsOptions",
              "cornersDotOptions",
              "cornersSquareOptions",
            ];
            _this.stylesList.forEach((item, index) => {
              options[field[index]].type =
                item[Math.floor(Math.random() * item.length)];
            });

            qrCode.update(options);

            let blob = await qrCode.getRawData("png");
            const reader = new FileReader();

            const readAsDataURL = new Promise((resolve) => {
              reader.addEventListener("loadend", () => {
                resolve(reader.result);
              });
            });

            reader.readAsDataURL(blob);
            i++;

            // Wait for the FileReader to complete and get the result
            yield await readAsDataURL;
          }
        }

        let res = [];
        debounce(
          () => {
            (async () => {
              for await (const num of generator()) {
                res.push(num);
              }
              this.qrSvgDataUrl = res;
              this.loading = false;
            })();
          },
          !!timer ? 1500 : 0,
        );
      });
    },
    ranColor() {
      return new Promise((resolve, reject) => {
        let rand = this.colors[Math.floor(Math.random() * 10)];
        try {
          this.options.dotsOptions.gradient.colorStops = [
            { offset: 0, color: rand[0] },
            { offset: 1, color: rand[1] },
          ];
          resolve("resolve");
        } catch (e) {
          console.log("failed to generate random color: ", e);
          reject();
        }
      });
    },
    downloadSvgImg(base64, index) {
      const filename = `image-${this.options.data
        .trim()
        .replace(/\.*\s*/g, "_")}-${index}.png`;

      // create canvas in memory(not in DOM)
      let canvas = document.createElement("canvas");
      // get canvas context for drawing on canvas
      let context = canvas.getContext("2d");

      let pngData = "";

      // set canvas size
      canvas.width = 300;
      canvas.height = 300;
      // create image in memory(not in DOM)
      let image = new Image();
      // later when image loads run this
      image.onload = function () {
        // async (happens later)
        // clear canvas
        context.clearRect(0, 0, 300, 300);
        // draw image with SVG data to canvas
        context.drawImage(image, 0, 0, 300, 300);
        // snapshot canvas as png
        pngData = canvas.toDataURL("image/png");
        // pass png data URL to callback

        // Convert the Base64 string to a Blob
        const byteCharacters = atob(pngData.split(",")[1]); // Remove the data URL prefix
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" }); // Adjust the MIME type if needed

        // Create a temporary link element
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename; // Set the filename for the download

        // Trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }; // end async
      // start loading SVG data into in memory image
      image.src = base64;
    },
    downloadImg(base64, index) {
      const filename = `image-${this.options.data
        .trim()
        .replace(/\.*\s*/g, "_")}-${index}.png`;

      // Convert the Base64 string to a Blob
      const byteCharacters = atob(base64.split(",")[1]); // Remove the data URL prefix
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" }); // Adjust the MIME type if needed

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename; // Set the filename for the download

      // Trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    isGradient(opt) {
      let res = {
        color: "",
        color1: "",
        isGradient: false,
      };

      if (opt.hasOwnProperty("gradient") && !!opt.gradient) {
        res = {
          isGradient: true,
          color: opt.gradient.colorStops[0].color,
          color1: opt.gradient.colorStops[1].color,
        };
      } else
        res = {
          isGradient: false,
          color: opt.color,
          color1: null,
        };

      return res;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.advance-image-data,
.advance-image-data >>> svg {
  max-width: 100%;
  max-height: 120px;
}
</style>
